module.exports = __webpack_public_path__ + "media/images/about/b2@2x-a0f5589f7da447e08298f1ac1b4fd17e.png";